import React, { Fragment } from "react";
import {
  TBody,
  THead,
  Table,
  TableWrapper,
  Td,
  Th,
  Tr,
} from "Components/Common/Table/TableT1";
import {
  TypographyT43,
  TypographyT44,
  TypographyT441,
  TypographyT45,
  TypographyT46,
  TypographyT47,
  TypographyT62,
} from "Components/Common/Typography/index";
import Moment from "moment";
import { ReactComponent as DownloadIconT1 } from "Icons/downloadIconT1.svg";
import { ReactComponent as FileSearchIcon } from "Icons/fileSearchIcon.svg";
import { ReactComponent as PencilIcon } from "Icons/pencilIcon.svg";
import styled from "@emotion/styled";
import { FlexWrapperT2 } from "Components/Common/Wrapper/FlexWrapper";
import { IconButtonT1 } from "Components/Common/Button/index";
import TooltipT1 from "Components/Common/ToolTip/TooltipT1";
import AdditionalFilesTable from "./AdditionalFilesTable";

const InprogressAndCompletedTable = (props) => {
  const {
    selectedTab,
    inprogressShipmentDetailsList,
    completedShipmentDetailsList,
    handleOnclickForMoreInformationPopup,
    handleOnClickDownloadContainerBlTrackingFile,
    handleOnClickAdditionalFiles,
    handleOnclickEventStatusInformationPopup,
    handleOnClickOnDemandTracking
  } = props;

  const getData = () => {
    if (selectedTab === 2) {
      return inprogressShipmentDetailsList;
    } else if (selectedTab === 3) {
      return completedShipmentDetailsList;
    }
  };

  const stickyHeader = {
    'position': 'sticky',
    'top': '0px'
  }

  const getStatusColor = (status) => {
    let colorValue = '';
    const cStatus = ((status || '').toLowerCase());
    if(cStatus.includes('delayed')) {
      colorValue = '#cb0d38';
    } else if(cStatus.includes('early')) {
      colorValue = '#FF9900';
    }
    return colorValue;
  }

  return (
    <Fragment key={selectedTab}>
      <TableWrapper>
        <Table>
          <THead>
            <Tr>
              <Th style={stickyHeader}>SL No.</Th>
              <Th style={stickyHeader}>Upload Date</Th>
              <Th style={stickyHeader}>Data Refreshed on (Date / Time)</Th>
              <Th style={stickyHeader}>Tracking Request N0.</Th>
              <Th style={stickyHeader}>Container No.</Th>
              <Th style={stickyHeader}>BL No.</Th>
              <Th style={stickyHeader}>Product Name</Th>
              <Th style={stickyHeader}>STO No.</Th>
              <Th style={stickyHeader}>Category</Th>
              <Th style={stickyHeader}>Origin Port</Th>
              <Th style={stickyHeader}>ETD (Origin Port)</Th>
              <Th style={stickyHeader}>ATD(Actual Time of Dept.)</Th>
              <Th style={stickyHeader}>Destination Port</Th>
              <Th style={stickyHeader}>ETA (Manual / SAP)</Th>
              <Th style={stickyHeader}>Revised Actual Time of Arr.</Th>
              <Th style={stickyHeader}>ATA(Actual Time of Arr.)</Th>
              <Th style={stickyHeader}>Current Location</Th>
              <Th style={stickyHeader}>Latest Destination</Th>
              <Th style={stickyHeader}>Status</Th>
              {selectedTab === 2 && <Th style={stickyHeader}>No. of days left to be delivered in destination port</Th>}
              {selectedTab === 3 && <Th style={stickyHeader}>Detention at destination Port(In days)</Th>} 
              <Th style={stickyHeader}>Action</Th>
            </Tr>
          </THead>
          <TBody>
            {getData().map((ele, ind) => {
              const currentEvent = [];
              (ele.events || []).forEach((cEvent) => {
                if (Moment(cEvent.date).valueOf() <= Moment().valueOf()) {
                  currentEvent.push(cEvent);
                }
              });
              return (
                <Fragment key={ind}>
                  <Tr>
                    <Td>
                      <TypographyT43>{ind + 1}</TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {!!ele.exim_cargo_details.created &&
                          Moment(ele.exim_cargo_details.created).format("DD/MM/YYYY HH:mm:ss")}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {!!ele.created &&
                          Moment(ele.created).format("DD/MM/YYYY HH:mm:ss")}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {ele.exim_cargo_details.tracking_request_number}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT44>{ele.container_number}</TypographyT44>
                      <TypographyT45
                        onClick={() => {
                          handleOnClickAdditionalFiles(ele);
                        }}
                      >
                        Additional Docs
                      </TypographyT45>
                      <TypographyT62
                      >
                        {ele.exim_cargo_details.sap_message}
                      </TypographyT62>
                      <TypographyT441>
                        {ele.exim_cargo_details.invoice_updated_message}
                      </TypographyT441>
                      {/* <TooltipT1>
                        <AdditionalFilesTable />
                      </TooltipT1> */}
                    </Td>
                    <Td>
                      <TypographyT46>
                       {(ele.exim_cargo_details || {}).bl_number || '-'}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT46>
                       {(ele.exim_cargo_details || {}).sku_details && (ele.exim_cargo_details || {}).sku_details[0].product_name || '-'}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT46>
                      {(ele.exim_cargo_details || {}).sto_details && (ele.exim_cargo_details || {}).sto_details[0].sto_number || '-'}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT46>
                      {(ele.exim_cargo_details || {}).category || '-'}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT46>
                        {`${(ele.from || {}).from}, ${
                          (ele.from || {}).state
                        }, ${(ele.from || {}).country}`}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {(ele.exim_cargo_details || {}).eta_planned_source_port &&
                          Moment((ele.exim_cargo_details || {}).eta_planned_source_port).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {((ele.from || {}).actual &&
                          Moment((ele.from || {}).date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )) ||
                          "-"}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT46>
                        {`${(ele.to || {}).from}, ${(ele.to || {}).state}, ${
                          (ele.to || {}).country
                        }`}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {!!ele.eta_date &&
                          Moment(ele.eta_date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {!!ele.revised_date &&
                          Moment(ele.revised_date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {((ele.to || {}).actual &&
                          Moment((ele.to || {}).date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )) ||
                          "-"}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT46>
                        {currentEvent[currentEvent.length - 1].name}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT46>
                        {(ele.firstRailDoc || {}).currentlocation}
                      </TypographyT46>
                      <TypographyT46>
                        {(ele.firstRailDoc || {}).timestamptimezone && Moment((ele.firstRailDoc || {}).timestamptimezone).format(
                            "DD/MM/YYYY HH:mm:ss"
                          ) || '-'}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT47 style={{'color': getStatusColor(ele.status)}}>{ele.status}</TypographyT47>
                      {(ele.trackLog && ele.trackLog.length > 0) && (<TypographyT45
                        onClick={() => {
                          handleOnclickEventStatusInformationPopup(ele);
                        }}
                      >
                        Domestic Tracking
                      </TypographyT45>)}
                      {(ele.trackLog && ele.trackLog.length === 0 && ele.domesticErrorStatus) && <TypographyT46 style={{'color': '#cb0d38', 'marginTop': '10px'}}><b>{(ele.domesticErrorStatus || {}).errorMessage} - {(ele.domesticErrorStatus || {}).responseStatus}</b></TypographyT46>}
                    </Td>
                    {selectedTab === 2  && <Td>
                      <TypographyT46>
                        {ele.remaining_days}
                      </TypographyT46>
                    </Td>}
                    {selectedTab === 3  && <Td>
                      <TypographyT46>
                        {ele.detention_destination_port_day || '-'}
                      </TypographyT46>
                    </Td>}
                    <Td>
                      <FlexWrapperT2>
                        <IconButtonT1
                          onClick={() => {
                            handleOnclickForMoreInformationPopup(ele);
                          }}
                        >
                          <FileSearchIcon />
                        </IconButtonT1>
                        {/* {selectedTab === 2 && (
                          <IconButtonT1>
                            <PencilIcon />
                          </IconButtonT1>
                        )} */}
                        {/* <IconButtonT1
                          onClick={() => {
                            handleOnClickDownloadContainerBlTrackingFile(
                              ele.container_number
                            );
                          }}
                        >
                          <DownloadIconT1 />
                        </IconButtonT1> */}
                      </FlexWrapperT2>
                      {selectedTab === 2  && <TypographyT45
                        onClick={() => {
                          handleOnClickOnDemandTracking(ele.container_number);
                        }}
                      >
                        OnDemand Tracking
                      </TypographyT45>}
                    </Td>
                  </Tr>
                </Fragment>
              );
            })}
          </TBody>
        </Table>
      </TableWrapper>
    </Fragment>
  );
};

export default InprogressAndCompletedTable;
